import React, { useContext, useEffect, useState } from "react";
import * as XLSX from "xlsx-js-style";
import { AuthContext, LoaderContext } from "../../Context/ContextFunctions";
import { FaEdit, FaFileExport } from "react-icons/fa";
import { MdPhotoLibrary } from "react-icons/md"
import NoResultFoundModel from "../../components/common/NoDataFound";
import PaginationComponent from "../../components/common/PaginationModal";
import { GetJobCategoryLookupList, GetJobList } from "../../services/Job/JobApi";
import { Dialog, DialogContent, IconButton, Tooltip } from "@mui/material";
import Android12Switch from "../../components/common/AndroidSwitch";
import { IoClose } from "react-icons/io5";
import Select from "react-select";
import { CalenderFilterEnum, globalSelectStyles } from "../../middleware/enum";
import { GetClientLookupList } from "../../services/Client/ClientApi";
import { GetAllProjectLookupList, GetProjectLookupList } from "../../services/Project/projectApi";
import { GeStatusLookupList, GetAllUserLookupList } from "../../services/Staff/StaffApi";
import CalendarFilter from "../../components/common/CalenderFilter";
import dayjs from "dayjs";
import { GetAttendanceReportList } from "../../services/Reports/ReportsApi";
import MapLocationCell from "../../components/common/MapLocationCell";

export default function AttendanceReportListComponent() {
    //========================constant=======================
    const { userKeyID } = JSON.parse(localStorage.getItem("login"))
    const { setLoader } = useContext(LoaderContext);
    const { formatDateDMY, pageSize, } = useContext(AuthContext);

    // =================== Column Configs =====================
    const tableColumnsConfig = [
        { key: "employeeName", label: "Employee Name" },
        { key: "projectName", label: "Project Name" },
        { key: "attendanceDate", label: "Date", },
        { key: "checkInTime", label: "Check-In Time" },
        { key: "checkOutTime", label: "Check-Out Time" },
        { key: "checkInLocation", label: "Check-In Location" },
        { key: "checkOutLocation", label: "Check-Out Location" },
        { key: "odometerStartReading", label: "Odometer Start Reading" },
        { key: "odometerEndReading", label: "Odometer End Reading" },
        // { key: "infoAtSmartWork", label: "Info" },
        { key: "siteSelection", label: "Site Selection" },
        { key: "photos", label: "Photos" },
        { key: "reason", label: "Reason" },
        { key: "remark", label: "Remark", truncate: 10 },
        { key: "attendanceStatus", label: "Status" },
    ]

    //========================state=======================
    const [valueSearch, setValueSearch] = useState(null)
    const [tableRows, setTableRows] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [fromDate, setFromDate] = useState(dayjs().startOf("week"));
    const [toDate, setToDate] = useState(dayjs().endOf("week"));
    const [searchTimer, setSearchTimer] = useState(null)
    const [photoDialogOpen, setPhotoDialogOpen] = useState(false);
    const [selectedPhotos, setSelectedPhotos] = useState({
        checkInSelfie: null,
        odometerStartImage: null,
        checkOutImage: null,
    });
    const [lookupList, setLookupList] = useState({
        clientList: [],
        projectList: [],
        employeeList: [],
        jobCategoryList: [],
        statusList: [],
    })
    const [listId, setListId] = useState({
        clientID: null,
        projectID: null,
        userID: null
    });

    const [appliedFilter, setAppliedFilter] = useState({
        userKeyID: userKeyID,
        userID: null,
        pageNo: 0,
        pageSize: pageSize,
        sortingDirection: null,
        sortingColumnName: null,
        searchKeyword: null,
        fromDate: null,
        toDate: null,
    })

    //========================useEffect======================= 
    useEffect(() => {
        const fetchLookupData = async () => {
            setLoader(true);
            try {
                const [
                    // clientRes,
                    employeeRes,
                    // categoryRes,
                    // statusRes,
                ] = await Promise.all([
                    // GetClientLookupList(),
                    GetAllUserLookupList(),
                    // GetJobCategoryLookupList(),
                    // GeStatusLookupList()
                ]);

                setLookupList({
                    // clientList: mapToSelectOptions(
                    //     clientRes?.responseData?.data || [],
                    //     "clientName",
                    //     "clientID"
                    // ),

                    employeeList: mapToSelectOptions(
                        employeeRes?.responseData?.data || [],
                        "name",
                        "userID"
                    ),

                    // jobCategoryList: mapToSelectOptions(
                    //     categoryRes?.responseData?.data || [],
                    //     "categoryName",
                    //     "categoryID"
                    // ),

                    // projectList: [],   // add later if needed
                    // statusList: mapToSelectOptions(
                    //     statusRes?.responseData?.data || [],
                    //     "projectStatusName",
                    //     "projectStatusID"
                    // ),
                });
            } catch (error) {
                console.log("Lookup fetch error:", error);
            } finally {
                setLoader(false);
            }
        };

        fetchLookupData();
    }, []);



    useEffect(() => {

        async function fetchData() {
            setLoader(true);
            const response = await GetAttendanceReportList({
                ...appliedFilter,
                // partiesTypeID: activeTab,
            });
            setLoader(false);

            if (response?.statusCode == 200) {
                setTableRows(response.responseData.data);
                setTotalRecords(response?.totalCount || response?.responseData?.data?.length || 0);
            } else {
                setTableRows([]);
                setTotalRecords(0);
            }
        }

        if (appliedFilter.fromDate && appliedFilter.toDate) fetchData();
    }, [appliedFilter, fromDate, toDate]);

    //========================functions=======================
    const mapToSelectOptions = (list = [], labelKey, valueKey) => {
        return list.map(item => ({
            label: item[labelKey],
            value: item[valueKey],
        }));
    };

    const getLabelByValue = (list = [], value) => {
        return list.find(item => item.value === value)?.label || "";
    };

    const handleJobExport = () => {
        const wb = XLSX.utils.book_new();

        const titleText = "Title: Attendance Report";
        const filterRows = [];
        if (appliedFilter.userID) {
            filterRows.push([
                "Employee",
                getLabelByValue(lookupList.employeeList, appliedFilter.userID)
            ]);
        }

        if (appliedFilter.fromDate) {
            filterRows.push([
                "Start Date",
                appliedFilter.fromDate
            ]);
        }

        if (appliedFilter.toDate) {
            filterRows.push([
                "End Date",
                appliedFilter.toDate
            ]);
        }
        const headers = [
            "Employee Name",
            "Date",
            "Check In-Time",
            "Check Out-Time",
            "Attendance Status",
        ];

        const data = tableRows.map((row) => [
            row.employeeName || "-",
            row.attendanceDate ? row.attendanceDate : "-",
            row.checkInTime || "-",
            row.checkOutTime || "-",
            row.attendanceStatus || "-",
        ]);

        const ws_data = [
            [titleText],
            [],
            ...(filterRows.length ? [["Applied Filters"]] : []),
            ...filterRows,
            ...(filterRows.length ? [[]] : []),
            [],
            headers,
            ...data
        ];

        const headerRowIndex =
            1 + 1 +
            (filterRows.length ? 1 + filterRows.length + 1 : 0) +
            1;


        const ws = XLSX.utils.aoa_to_sheet(ws_data);
        // Merge title row
        ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }];
        ws["A1"].s = {
            font: { bold: true, sz: 14 },
            alignment: { horizontal: "left", vertical: "left" },
        };

        // Header row styling (row 2 / index 2)
        headers.forEach((_, col) => {
            const cellAddr = XLSX.utils.encode_cell({ c: col, r: headerRowIndex });
            if (ws[cellAddr]) {
                ws[cellAddr].s = {
                    font: { bold: true, color: { rgb: "000000" } },
                    alignment: { horizontal: "center", vertical: "center" },
                    fill: {
                        fgColor: { rgb: "D9E1F2" } // subtle header background
                    },
                    border: {
                        top: { style: "medium", color: { rgb: "000000" } },
                        bottom: { style: "medium", color: { rgb: "000000" } },
                        left: { style: "medium", color: { rgb: "000000" } },
                        right: { style: "medium", color: { rgb: "000000" } },
                    },
                };
            }
        });

        const dataStartRow = headerRowIndex + 1;

        // Data row styling
        for (let r = dataStartRow; r < data.length + dataStartRow; r++) {
            for (let c = 0; c < headers.length; c++) {
                const cellAddr = XLSX.utils.encode_cell({ c, r });

                if (ws[cellAddr]) {
                    ws[cellAddr].s = {
                        font: { color: { rgb: "000000" } },
                        alignment: {
                            horizontal: "center",
                            vertical: "center"
                        },
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } },
                            bottom: { style: "thin", color: { rgb: "000000" } },
                            left: { style: "thin", color: { rgb: "000000" } },
                            right: { style: "thin", color: { rgb: "000000" } },
                        },
                    };

                    // Zebra rows
                    if ((r - dataStartRow) % 2 === 1) {
                        ws[cellAddr].s.fill = { fgColor: { rgb: "F7F7F7" } };
                    }
                }
            }
        }

        // Column widths for readability
        ws["!cols"] = headers.map((h) => ({ wch: h.length + 8 }));

        XLSX.utils.book_append_sheet(wb, ws, "Attendance Report");
        XLSX.writeFile(wb, "Attendance_Report.xlsx");
        setAppliedFilter({ ...appliedFilter, pageNo: 0, pageSize: pageSize })
    };

    const handleSearchFunction = (searchValue) => {
        setValueSearch(searchValue);

        // Clear old timer so API doesn't fire immediately
        if (searchTimer) clearTimeout(searchTimer);

        // Set new timer
        const timer = setTimeout(() => {
            setAppliedFilter({
                ...appliedFilter,
                searchKeyword: searchValue || null,
            });
        }, 500); // 500ms delay

        setSearchTimer(timer);
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        setAppliedFilter((prev) => ({ ...prev, pageNo: pageNumber - 1 }));
    }


    //=====================render table=====================
    const renderTable = (columns = [], data = []) => {
        if (!columns.length) return null;

        return (
            <div className="flex flex-col table_wrapper ">
                <div className="flex-1 ">
                    <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                        <thead>
                            <tr className="z-1 sticky top-0 bg-white">
                                {columns.map((col) => (
                                    <th
                                        key={col.key}
                                        className="text-12 border-b border-slate-200 bg-slate-50 whitespace-nowrap p-1"
                                    >
                                        {col.label}
                                    </th>
                                ))}

                            </tr>
                        </thead>
                        <tbody>
                            {data.length > 0 ? (
                                data.map((client, index) => (
                                    <tr
                                        key={index}
                                        className="hover:bg-slate-50 border-b border-slate-200 text-center"
                                    >
                                        {columns.map((col) => {
                                            if (col.key === "photos") {
                                                const photos = client.photos || [];

                                                return (
                                                    <td
                                                        key={col.key}
                                                        className="px-2 py-2 text-center"
                                                    >
                                                        <Tooltip title="View Photos" arrow>
                                                            <span
                                                                onClick={() => {

                                                                    setSelectedPhotos({
                                                                        ...selectedPhotos,
                                                                        checkInSelfie: client.checkInSelfie,
                                                                        checkOutImage: client.checkOutImage,
                                                                        odometerStartImage: client.odometerStartImage,
                                                                        infoAtSmartWork: client.infoAtSmartWork
                                                                    });
                                                                    setPhotoDialogOpen(true);
                                                                }}
                                                                className="inline-flex items-center justify-center cursor-pointer"
                                                            >
                                                                <MdPhotoLibrary size={18} color="#135EA0" />
                                                            </span>
                                                        </Tooltip>

                                                    </td>
                                                );
                                            }

                                            const cellValue = client[col.key] || "";
                                            const isLongText = cellValue.length > 50;

                                            const value = client[col.key];
                                            if (col.truncate) {
                                                const truncated =
                                                    value && value.length > col.truncate
                                                        ? value.slice(0, col.truncate) + "..."
                                                        : value;

                                                return (
                                                    <td key={col.key} className="whitespace-nowrap px-2 py-0">
                                                        <Tooltip title={value || ""}>
                                                            <span className="cursor-pointer">{truncated}</span>
                                                        </Tooltip>
                                                    </td>
                                                );
                                            }

                                            if (col.key === "attendanceStatus") {
                                                const status = client[col.key];

                                                const statusColor =
                                                    status?.toLowerCase() === "present"
                                                        ? "text-green-600 bg-green-50"
                                                        : status?.toLowerCase() === "absent"
                                                            ? "text-red-600 bg-red-50"
                                                            : "text-gray-600 bg-gray-50";

                                                return (
                                                    <td key={col.key} className="px-2 py-2 text-center">
                                                        <span
                                                            className={`px-2 py-1 rounded-full text-xs font-medium ${statusColor}`}
                                                        >
                                                            {status || "-"}
                                                        </span>
                                                    </td>
                                                );
                                            }
                                            if (col.key === "checkInLocation") {
                                                return (
                                                    <td key={col.key} className="px-2 py-2 text-center">
                                                        {client?.checkInLat && client?.checkInLong ? (
                                                            <button
                                                                className="p-2  cursor-pointer  hover:text-green-700 text-green-600"
                                                            >
                                                                <MapLocationCell
                                                                    latitude={client?.checkInLat}
                                                                    longitude={client?.checkInLong}
                                                                />
                                                            </button>) : ('-')}
                                                    </td>
                                                )
                                            }

                                            if (col.key === "checkOutLocation") {
                                                return (
                                                    <td key={col.key} className="px-2 py-2 text-center">
                                                        {client?.checkOutLat && client?.checkOutLong ? (
                                                            <button
                                                                className="p-2  cursor-pointer  hover:text-green-700 text-green-600"
                                                            >
                                                                <MapLocationCell
                                                                    latitude={client?.checkOutLat}
                                                                    longitude={client?.checkOutLong}
                                                                />
                                                            </button>) : ('-')}
                                                    </td>
                                                )
                                            }

                                            return (
                                                <td
                                                    key={col.key}
                                                    className="whitespace-nowrap px-2 py-2 text-xs leading-tight"
                                                >
                                                    {isLongText ? (
                                                        <Tooltip title={cellValue} arrow>
                                                            <span className="inline-block truncate max-w-[200px] cursor-pointer">
                                                                {cellValue}
                                                            </span>
                                                        </Tooltip>
                                                    ) : (
                                                        cellValue
                                                    )}
                                                </td>
                                            );
                                        })}

                                    </tr>

                                ))
                            ) : (
                                <tr>
                                    <td colSpan={columns.length + 1}>
                                        <NoResultFoundModel totalRecords={totalRecords} />
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div >

                {/* Pagination */}

            </div >
        );
    };

    return (
        <div>
            <>
                <div className="bg-gray-50 mx-auto rep-width">
                    <div className="h-full bg-white shadow rounded-lg flex flex-col">
                        {/* Header Section */}

                        <div className="p-2 border-b flex flex-col gap-2 md:flex-row md:items-center md:justify-between md:gap-4">
                            {/* Dropdown Filters */}
                            <div className="flex flex-col md:flex-row gap-2 w-full">
                                {/* User filter */}
                                {/* <div className="w-full md:w-[220px]">
                                    <Select
                                        options={lookupList?.clientList}
                                        placeholder="Select Client"
                                        isClearable
                                        styles={globalSelectStyles}
                                        onChange={async (selectedOptions) => {

                                            try {
                                                const res = await GetProjectLookupList(selectedOptions.value)

                                                if (res?.statusCode === 200) {
                                                    setLookupList({
                                                        ...lookupList,
                                                        projectList: mapToSelectOptions(
                                                            res?.responseData?.data || [],
                                                            "projectName",
                                                            "projectID"
                                                        ),

                                                    });
                                                }
                                            } catch (err) {
                                                console.log("error==>>", err)
                                            } finally {
                                                setAppliedFilter({
                                                    ...appliedFilter,
                                                    clientID: selectedOptions?.value
                                                })

                                            }
                                            setListId({
                                                ...listId,
                                                clientID: selectedOptions?.value
                                            })
                                        }}
                                        value={lookupList?.clientList?.find(
                                            (option) => option.value === listId?.clientID || null
                                        )}
                                    />
                                </div> */}
                                {/* Project Name Dropdown */}
                                {/* <div className="w-full md:w-[220px]">
                                    <Select
                                        options={lookupList?.projectList}
                                        placeholder="Select Project Name"
                                        isClearable
                                        styles={globalSelectStyles}
                                        onChange={(selectedOption) => {
                                            setAppliedFilter({
                                                ...appliedFilter,
                                                projectID: selectedOption?.value
                                            })
                                            setListId({
                                                ...listId,
                                                projectID: selectedOption.value
                                            })
                                        }}
                                        value={lookupList?.projectList?.find(
                                            (option) => option.value === listId?.projectID
                                        )}
                                    />
                                </div> */}

                                {/* Status Name Dropdown */}
                                <div className="w-full md:w-[220px]">
                                    <Select
                                        options={lookupList?.employeeList}
                                        placeholder="Select Employee Name"
                                        isClearable
                                        styles={globalSelectStyles}
                                        onChange={(options) => {
                                            setAppliedFilter({
                                                ...appliedFilter,
                                                userID: options?.value
                                            })
                                            setListId({
                                                ...listId,
                                                userID: options?.value
                                            })
                                        }}
                                    />
                                </div>

                                <div className="w-full md:w-[200px]">
                                    <CalendarFilter
                                        onDateChange={(fromDate, toDate) => {
                                            setFromDate(fromDate);
                                            setToDate(toDate);
                                            setCurrentPage(1);

                                            setAppliedFilter({
                                                ...appliedFilter,
                                                fromDate: fromDate,
                                                toDate: toDate
                                            })
                                        }}
                                        toDate={toDate}
                                        setToDate={setToDate}
                                        fromDate={fromDate}
                                        setFromDate={setFromDate}
                                        hideAllOption={true} // ✅ Hide "All" option only here
                                        defaultSelectedOption={{
                                            value: CalenderFilterEnum.This_Week,
                                            label: "This Week",
                                        }} // Set default to "This Week"
                                    />
                                </div>

                                {/* Service Name Dropdown */}
                                {/* <div className="w-full md:w-[220px]">
                                    <Select
                                        options={lookupList?.statusList}
                                        placeholder="Select Status"
                                        isClearable
                                        styles={globalSelectStyles}
                                        onChange={(option) => {
                                            setListId({
                                                ...listId,
                                                statusId: option.value
                                            })
                                            setAppliedFilter({
                                                ...appliedFilter,
                                                statusId: option.value
                                            })
                                        }}

                                    />
                                </div> */}
                            </div>

                            {/* Right-side: Export + Search */}
                            <div className="flex flex-col md:flex-row gap-2 md:items-center w-full md:w-auto">
                                <button
                                    className="flex items-center text-[#135EA0] text-12"
                                    onClick={() => {
                                        setAppliedFilter({ ...appliedFilter, pageSize: 40 })

                                        setTimeout(() => {
                                            handleJobExport();
                                        }, 100);
                                    }}
                                >
                                    <FaFileExport className="mr-1" />
                                    Export
                                </button>
                                {/* Filter Input */}

                                {/* Filter Button */}
                                {/* <button className="flex items-center text-[#135EA0] text-12">
                                <FaFilter className="mr-1" />
                                Filter
                              </button> */}
                                {/* Search Input */}

                                <div className="relative w-full md:w-64">
                                    <input
                                        type="text"
                                        className="w-full border border-gray-200 text-12 shadow appearance-none rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600"
                                        placeholder="Search..."
                                        value={valueSearch}
                                        onChange={(e) => handleSearchFunction(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Tab Content */}
                        <div className="flex flex-col table_wrapper border border-gray-200">
                            <div className="flex-1 overflow-y-auto">
                                {renderTable(tableColumnsConfig, tableRows || [])}
                                {totalRecords <= 0 && (
                                    <NoResultFoundModel totalRecords={totalRecords} />
                                )}
                            </div>

                            {/* Pagination */}
                            {totalRecords > pageSize && (
                                <div className="flex justify-end ">
                                    <PaginationComponent
                                        totalPages={Math.ceil(totalRecords / pageSize)}
                                        currentPage={currentPage}
                                        onPageChange={handlePageChange}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </>
            <Dialog
                open={photoDialogOpen}
                onClose={() => setPhotoDialogOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                <div className="flex justify-between items-center px-4 py-2 border-b">
                    <h3 className="text-sm font-semibold">Attendance Images</h3>
                    <IconButton onClick={() => setPhotoDialogOpen(false)}>
                        <IoClose />
                    </IconButton>
                </div>

                <DialogContent>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

                        {/* Check-In Selfie */}
                        <div className="flex flex-col items-center">
                            {selectedPhotos.checkInSelfie ? (
                                <img
                                    src={selectedPhotos.checkInSelfie}
                                    alt="Check-In Selfie"
                                    className="w-full h-40 object-cover rounded-lg border transition-transform duration-300 hover:scale-110"
                                />
                            ) : (
                                <div className="w-full h-40 flex items-center justify-center border rounded-lg text-xs text-gray-400">
                                    No image
                                </div>
                            )}
                            <p className="mt-2 text-xs font-medium text-gray-700">
                                Check-In Selfie
                            </p>
                        </div>

                        {/* Odometer Start Image */}
                        <div className="flex flex-col items-center">
                            {selectedPhotos.odometerStartImage ? (
                                <img
                                    src={selectedPhotos.odometerStartImage}
                                    alt="Odometer Start"
                                    className="w-full h-40 object-cover rounded-lg border transition-transform duration-300 hover:scale-110"
                                />
                            ) : (
                                <div className="w-full h-40 flex items-center justify-center border rounded-lg text-xs text-gray-400">
                                    No image
                                </div>
                            )}
                            <p className="mt-2 text-xs font-medium text-gray-700">
                                Odometer Start Image
                            </p>
                        </div>

                        {/* Check-Out Image */}
                        {/* <div className="flex flex-col items-center">
                            {selectedPhotos.checkOutImage ? (
                                <img
                                    src={selectedPhotos.checkOutImage}
                                    alt="Check-Out"
                                    className="w-full h-40 object-cover rounded-lg border transition-transform duration-300 hover:scale-110"
                                />
                            ) : (
                                <div className="w-full h-40 flex items-center justify-center border rounded-lg text-xs text-gray-400">
                                    No image
                                </div>
                            )}
                            <p className="mt-2 text-xs font-medium text-gray-700">
                                Check-Out Image
                            </p>
                        </div> */}
                        {/* Info Image */}
                        {/* <div className="flex flex-col items-center">
                            {selectedPhotos.infoAtSmartWork ? (
                                <img
                                    src={selectedPhotos.infoAtSmartWork}
                                    alt="info-at-smart-work"
                                    className="w-full h-40 object-cover rounded-lg border"
                                />
                            ) : (
                                <div className="w-full h-40 flex items-center justify-center border rounded-lg text-xs text-gray-400">
                                    No image
                                </div>
                            )}
                            <p className="mt-2 text-xs font-medium text-gray-700">
                                Info At Start Work

                            </p>
                        </div> */}
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    )
}